import React from 'react';
import {
    Table,
    Row,
    Spin,
    Button,
} from 'antd';

import { asyncGet, actions, asyncGetUserList, asyncGetTaskInfo } from './reducers';
import { connect } from 'react-redux';
import SearchForm from './search.js';
import Edit from './edit.js';
import moment from 'moment';


class AgencyAnalysis extends React.Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        this.props.asyncGet();
        this.props.asyncGetUserList();
    }

    changeHandle = (pagination, filters, sorter) => {
        this.props.changePagination(pagination);
        this.props.asyncGet();
    };
    /**
     * 分页器改变数据处理
     */
    handlePaginationChange = (current, pageSize) => {
        let pagination = {
            current,
            pageSize,
        };
        this.props.changePagination(pagination);
        this.props.asyncGet();
    };

    edit = (record, type) => {
        this.props.editShow();
        this.props.asyncGetTaskInfo(record, type);
    }

    renderAction = (text, record) => {
        // console.log(expanded, record);
        const today = moment().format('YYYY-MM-DD');
        const time = moment().format('HH:mm:hh');
        let flag = false;
        if (record.tr === '1000' && time > '12:00:00') {
            flag = true;
        }
        return (
            <div>
                {record.type ? (
                    <Button type="primary" style={{ marginRight: '5px' }} size="small" onClick={() => {
                        this.edit(record, 0);
                    }}>
                        查看
                    </Button>
                ) : ''}
                {
                    record.type ? '' : (
                        record.tm < today || flag ? '未签到' : (
                            <Button type="danger" style={{ marginRight: '5px' }} size="small" onClick={() => {
                                this.edit(record, 1);
                            }}>
                                签到
                            </Button>
                        )
                    )
                }
            </div>
        );
    };

    render() {
        let { list, uiStatus } = this.props;
        let { isLoading } = uiStatus;
        const columns = [
            {
                title: '责任人',
                dataIndex: 'pricple',
                key: 'pricple',
            },
            {
                title: '时间',
                dataIndex: 'tm',
                key: 'tm',
            },
            {
                title: '时间段',
                dataIndex: 'tr',
                key: 'tr',
                render: text => {
                    let content = '';
                    if (text === '1000') {
                        content = '上午';
                    } else if (text === '1800') {
                        content = '下午';
                    } else {
                        content = text;
                    }
                    return content;
                },
            },
            {
                title: '状态',
                dataIndex: 'type',
                key: 'type',
                render: text => {
                    if (text == 1) {
                        return '有异常';
                    } else if (text == 2) {
                        return '正常';
                    } else {
                        return '未签到';
                    }
                },
            },
            {
              title: '备注',
              dataIndex: 'resolve',
              key: 'resolve',
            },
            {
                title: '操作时间',
                dataIndex: 'createTime',
                key: 'createTime',
                render: text => {
                    if (text) {
                        return moment(text).format('YYYY-MM-DD HH:mm:ss');
                    } else {
                        return '';
                    }
                },
            },
            {
                title: '操作',
                dataIndex: 'action',
                key: 'action',
                render: (text, record, index) => {
                    return this.renderAction(text, record, index);
                },
            },
        ];

        return (
            <div style={{ marginBottom: '20px' }}>
                <Row style={{ marginTop: '10px', marginTop: '10px' }}>
                    <SearchForm {...this.props} />
                </Row>

                <Spin spinning={isLoading} tip="加载中...">
                    <Table
                        columns={columns}
                        dataSource={list}
                        pagination={false}
                    />
                    {/* <Row type="flex" justify="end">
                        <Pagination
                            style={{ padding: '10px 10px' }}
                            size="small"
                            showQuickJumper
                            pageSize={pageSize}
                            current={current}
                            total={total}
                            showTotal={(total, range) =>
                                `共 ${total ? total : '0'} 条记录，每页 ${pageSize} 条，这是第 ${totalPage
                                    ? current + '/' + totalPage
                                    : '1'} 页`}
                            showSizeChanger
                            pageSizeOptions={['10', '15', '20', '40']}
                            onShowSizeChange={this.handlePaginationChange}
                            onChange={this.handlePaginationChange}
                        />
                    </Row> */}
                    <Edit />
                </Spin>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    list: state.signList.list,
    pagination: state.signList.pagination,
    proxyrepeatinfo: state.signList.proxyrepeatinfo,
    uiStatus: state.signList.uiStatus,
    agentsGroup: state.signList.agentsGroup,
    transferData: state.signList.transferData,
});
const mapDispatchToProps = dispatch => ({
    asyncGet: () => dispatch(asyncGet()),
    editShow: () => dispatch(actions.changeUiStatus({ isUpdateShow: true })),
    asyncGetTaskInfo: (record, type) => dispatch(asyncGetTaskInfo(record, type)),
    asyncGetUserList: () => dispatch(asyncGetUserList()),
});
export default connect(mapStateToProps, mapDispatchToProps)(AgencyAnalysis);






// WEBPACK FOOTER //
// ./pages/sign/signList/index.js